import { render, staticRenderFns } from "./PostsInfo.vue?vue&type=template&id=9a4a3ea8"
import script from "./PostsInfo.vue?vue&type=script&lang=js"
export * from "./PostsInfo.vue?vue&type=script&lang=js"
import style0 from "./PostsInfo.vue?vue&type=style&index=0&id=9a4a3ea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports